const appConfig = '/commons-app-config-service/api';
export const config = {
     byType: appConfig + "/v1/app-config/app/type?",
     uploadAttachment: appConfig + '/v1/app-configs/attachment'
}